import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleAddModal, setPage, setActiveUsersTab, setMaxPages, setSorting, setCheckedItem } from '../../store/userTabSlice.js';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  empty,
} from './userTableConfig.js';
import { fetchUsers } from './userTableService.js';
import Table from '../../components/list2/table';
import Pagination from '../../components/components/pagination/pagination.jsx';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';

import AddUser from "./addUser";
import ViewUser from "./viewUser";

import './User.css'

function Users2() {
  const dispatch = useDispatch();
  const activeUsersTab = useSelector((state) => state.users.activeUsersTab);
  const totalPages = useSelector((state) => state.users.maxPages);
  const currentPage = useSelector((state) => state.users.currentPage);
  const role = useSelector((state) => state.users.role);
  const sortBy = useSelector((state) => state.users.sortBy);
  const sortDirection = useSelector((state) => state.users.sortDirection);
  const checkedItems = useSelector((state) => state.users.checkedItems);
  const keyword = useSelector((state) => state.users.keyword);
  const [rows, setRows] = useState([]);
  const sortArrowColorActive = '#FFFFFF';
  const sortArrowColorInactive = 'rgba(255,255,255,0.45)';

  const searchValue  = useSelector((state) => state.users.searchValue);

  const addModalOpen = useSelector((state) => state.users.addModalOpen );
  const editModalOpen = useSelector((state) => state.users.editModalOpen );

  const handleToggleAddModal = () => {
    dispatch(toggleAddModal());
  };

  useEffect(() => {
    fetchUsers(sortBy, sortDirection, currentPage, dispatch, setMaxPages, setRows, checkedItems, keyword);
  }, [currentPage, sortBy, sortDirection, checkedItems, keyword]);

  const headers = getHeaders(
    sortBy,
    sortDirection,
    dispatch,
    setSorting,
    sortArrowColorActive,
    sortArrowColorInactive,
    rows,
    checkedItems,
  );

  const paginationProps = {
    reduxSelector: (state) => state.users.currentPage,
    reduxAction: setPage,
    totalPages: totalPages,
    maxVisibleButtons: 5,
  };
  
  const rightSideConfig2 = [
    {
      component: Pagination, // Komponent do wyrenderowania
      props: paginationProps, // Właściwości przekazywane do komponentu
    },
  ];

  return (
    <div>
      {addModalOpen && <AddUser />}
      {editModalOpen && <ViewUser />}
      <Menu />
      <Content>
        <LineWithButtons tabs={tabsConfig(activeUsersTab, dispatch, setActiveUsersTab)} rightSide = {rightSideConfig(searchValue, dispatch)} buttons={buttonsConfig(handleToggleAddModal)} />
        <div className="table-container">
          <Table
            headers={headers}
            rows={rows}
            columnWidths={headerWidths}
            idViewing={false}
            idArrayId={1}
            cellClass2='cell-center'
            cellClass2ConditionList={[4, 5, 6, 7, 8]} />
          <UniversalLineWithComponents
            leftSide={leftSideConfig}
            rightSide={rightSideConfig2} />          
        </div>
      </Content>
    </div>
  );
}

export default Users2;